import React, { useEffect, useState, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import  { API } from "../../helper/Api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaPlus } from "react-icons/fa";


const AddStores = () => {
    const navigate = useNavigate();
    const goToEditStore = (corporatestorenbr) => {
      navigate("/editstores", {
        state: { corporatestorenbr }, // data passed via POST-like behavior
      });
    };
    const [CorpstoreNo, setCorpstoreNo] = useState("");
    const [ParentNo, setParentNo] = useState("");
    const [StoreName, setStoreName] = useState("");
    //const [extracts, setExtracts] = useState([]);
    const extractOptions = ["IMITMF", "IMINVF", "SAHDRF", "SALINF"];
    const [extracts, setExtracts] = useState(extractOptions);
    const [showExtractDropdown, setShowExtractDropdown] = useState(false);
    const [AccessToken, setAccessToken] = useState("");
    const [ApiKey, setApiKey] = useState("");
    const [ApiSecretKey, setApiSecretKey] = useState("");
    const [ShopifyWebsiteurl, setShopifyWebsiteurl] = useState("");
    const [ShopifyAdminurl, setShopifyAdminurl] = useState("");
    const [Utc, setUtc] = useState("");
    const [Utcdates, setUtcdates] = useState("");
    const [storeList, setStoreList] = useState([]);
  const [isDuplicate, setIsDuplicate] = useState(false);
  const [isPrefill, setIsPrefill] = useState(false);
  const [isNotExists, setIsNotExists] = useState(false);
  const [fieldsDisabled, setFieldsDisabled] = useState(false);
  const [StoreStatus, setStoreStatus] = useState("");
  const [storeCity, setStoreCity] = useState("");
const [storeState, setStoreState] = useState("");
const [combinedLocation, setCombinedLocation] = useState("");
const [locationIds, setLocationIds] = useState([""]);
  const [locationNames, setLocationNames] = useState([""]);
  const [multilocationcorpStoreNbrs, setmultilocationcorpStoreNbrs] = useState([]); // Only for new locations
  const [locationIdDuplicate, setLocationIdDuplicate] = useState(false);
const [corpStoreDuplicate, setCorpStoreDuplicate] = useState(false);

  const handleCorpStoreChange = (index, value) => {
    const updated = [...multilocationcorpStoreNbrs];
    updated[index - 1] = value; // only for rows after the first
    setmultilocationcorpStoreNbrs(updated);
  };
  
  const handleLocationIdChange = (index, value) => {
    const updatedIds = [...locationIds];
    updatedIds[index] = value;
    setLocationIds(updatedIds);
  };

  const handleLocationNameChange = (index, value) => {
    const updatedNames = [...locationNames];
    updatedNames[index] = value;
    setLocationNames(updatedNames);
  };

  const handleAddRow = () => {
    setLocationIds([...locationIds, ""]);
    setLocationNames([...locationNames, ""]);
  };
  // Prepare locations array
  const locations = locationIds.map((id, index) => ({
    corporatestorenbr: index === 0 ? CorpstoreNo : multilocationcorpStoreNbrs[index - 1],
    location_id: id,
    location_name: locationNames[index],
  }));
  //console.log("locations", locations);
  useEffect(() => {
    const handleClickOutside = (e) => {
        if (!e.target.closest(".dropdown")) {
          setShowExtractDropdown(false);
        }
      };

    API.storeSetting("get")
      .then((res) => {
        if (res && res.data) {
          setStoreList(res.data);
          // console.log("fetching store list:", res);
          console.log("fetching store list:", res.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching store list:", err);
      });

      document.addEventListener("click", handleClickOutside);
      return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const handleCorpstoreChange = (e) => {
  const value = e.target.value;
  setCorpstoreNo(value);

  if (value.trim() === "") {
    setIsDuplicate(false);
    setIsPrefill(false);
    setIsNotExists(false);
    setParentNo("");
    setStoreName("");
    return;
  }
  // const locduplicate = storeList.some(
  //   (store) => store.location_id?.toString().trim() === value.toString().trim()
  // );
  
  // setlocDuplicate(locduplicate);
  
  // if (locduplicate) {
  //   console.error("Duplicate location_id found in storeList!");
  // }
  
  // Check for duplicate (exists in all 3 fields)
  // const duplicate = storeList.some(
  //   (store) =>
  //     store.StoreNbr === value &&
  //     store.CorporateStorenbr === value &&
  //     store.shopify_corporatestorenbr === value,
  // );
  const duplicate = storeList.some(
  (store) =>
    store.StoreNbr?.toString().trim() === value.toString().trim() &&
    store.shopify_corporatestorenbr
);
  setIsDuplicate(duplicate);

  if (duplicate) {
    setIsPrefill(false);
    setIsNotExists(false);
    // setCorpstoreNo('');
    // setParentNo('');
    // setStoreName('');
  }

  // Check for prefill (exists in main store table but NOT in Shopify)
  // const prefillStore = storeList.find(
  //   (store) =>
  //     store.StoreNbr === value &&
  //     store.CorporateStorenbr === value &&
  //     store.shopify_corporatestorenbr === null
  // );
  const prefillStore = storeList.find(
  (store) =>
    store.StoreNbr?.toString().trim() === value.toString().trim() &&
    !store.shopify_corporatestorenbr
);

  if (prefillStore) {
    setIsPrefill(true);
    setIsNotExists(false);
    setParentNo(prefillStore.DSNStorenbr);
    setStoreName(prefillStore.StoreShortName);
    setStoreStatus(prefillStore.StoreStatus);
    setStoreCity(prefillStore.StoreCity);
    setStoreState(prefillStore.StoreState);
  
    const location = `${prefillStore.StoreCity}${prefillStore.StoreCity && prefillStore.StoreState ? ', ' : ''}${prefillStore.StoreState}`;
    setCombinedLocation(location);
  
    setFieldsDisabled(true);
  } else {
    setIsPrefill(false);
    setFieldsDisabled(false);
  }
  


  // If not duplicate and not prefill, check if it does not exist in any field
  // const IsNotExists = storeList.some(
  //   (store) =>
  //     store.StoreNbr === value ||
  //     store.CorporateStorenbr === value ||
  //     store.shopify_corporatestorenbr === value
  // );

  const IsNotExists = storeList.some(
  (store) => store.StoreNbr?.toString().trim() === value.toString().trim()
);

  if (!IsNotExists) {
    setIsNotExists(true);
    setIsPrefill(false);
    setParentNo('');
    setStoreName('');
    setStoreStatus('');
    setStoreCity('');
    setStoreState('');
    setCombinedLocation('');


  } else {
    setIsNotExists(false);
  }
  console.log("Checking StoreNbr:", value);
console.log("Matching Stores:", storeList.filter(s => s.StoreNbr == value));
};


    const handleFormSubmit = async (event) => {
        event.preventDefault();
          
        // Validate required fields
        if (
          !ParentNo ||
          !CorpstoreNo ||
          !StoreName ||
          !StoreStatus ||
          !storeCity ||
          !storeState ||
          !AccessToken ||
          !ApiKey ||
          !ApiSecretKey ||
          !ShopifyWebsiteurl ||
          !ShopifyAdminurl ||
          !Utc ||
          !Utcdates ||
          !multilocationcorpStoreNbrs||
          !locationIds.length ||
          !locationNames.length ||
          locationIds.some(id => !id.trim()) ||
          locationNames.some(name => !name.trim())
        ) {
          //alert("Please fill in all required fields.");
          toast.error("Please fill in all required fields.", {
                      position: "top-center",
                      autoClose: false,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      theme: "colored",
                      className: "login-toast",
                    });
          return;
        }
      
        // Debug logs
        console.log("Parent #:", ParentNo);
        console.log("CorpStore #:", CorpstoreNo);
        console.log("StoreName:", StoreName);
        console.log("Selected Extracts:", extracts);
        console.log("Access Token:", AccessToken);
        console.log("API Key:", ApiKey);
        console.log("API Secret Key:", ApiSecretKey);
        console.log("Shopify Websiteurl:", ShopifyWebsiteurl);
        console.log("Shopify Adminurl:", ShopifyAdminurl);
        console.log("UTC:", Utc);
        console.log("UTCDates:", Utcdates);
console.log("Location IDs:", locationIds);
console.log("Location Names:", locationNames);
console.log("Location Names:", locations);

      

        // Prepare form data
        const formData = {
          type: "insert",
          parentno: ParentNo,
          corporatestorenbr: CorpstoreNo,
          extract_name: extracts,
          access_token: AccessToken,
          api_key: ApiKey,
          api_secretkey: ApiSecretKey,
          shopify_websiteurl: ShopifyWebsiteurl,
          shopify_adminurl: ShopifyAdminurl,
          utc: Utc,
          utc_dates: Utcdates,
          // location_id: locationIds,
          // location_name: locationNames,
          locations: locations
        };
        console.log("Formdata", formData);
        try {
          const result = await API.storeSetting("insert", formData);
          if (result.error) {
            //alert(result.message || "Not Inserted");
            toast.error(result.message || "Not Inserted", {
                        position: "top-center",
                        autoClose: false,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        theme: "colored",
                        className: "login-toast",
                      });navigate("/addstores");
          } else {
            //alert(result.message || "Inserted Successfully!");
            toast.success(result.message || "Inserted Successfully!", {
                        position: "top-center",
                        autoClose: false,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        theme: "colored",
                        className: "login-toast",
                      });
            navigate("/liststores");
            // Clear all fields
            // setParentNo("");
            // setCorpstoreNo("");
            // // setStoreName("");
            // setExtracts([]); 
            // setAccessToken("");
            // setApiKey("");
            // setApiSecretKey("");
            // setShopifyWebsiteurl("");
            // setShopifyAdminurl("");
          }
        } catch (err) {
          console.error("Submission failed:", err);
          //alert("Error submitting form.");
          toast.error("Error submitting form.", {
            position: "top-center",
            autoClose: false,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "colored",
            className: "login-toast",
          });
        }
      };
      
      

const containerStyles = {
    padding: "30px",
    width: "60%",
    borderRadius: "8px",
    // backgroundColor: '#f8f9fa',
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)", // Light shadow for a floating effect
  };

  const labelStyles = {
    fontWeight: "600",
    marginBottom: "8px",
    fontSize: "14px",
  };

  const selectStyles = {
    width: "100%",
    padding: "8px",
    fontSize: "14px",
    borderRadius: "4px",
    border: "1px solid #ced4da",
    backgroundColor: "#fff",
     marginBottom: '15px',
    outline: "none",
    cursor: "pointer",
    height: "47px",
    color: "black",
  };

  const dropdownStyles = {
    position: "absolute",
    border: "1px solid #ced4da",
    backgroundColor: "#fff",
    width: "90%",
    zIndex: "1000",
    maxHeight: "200px",
    overflowY: "auto",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    borderRadius: "4px",
    padding: "10px",
  };

  const checkboxStyles = {
    margin: "5px 0",
  };

  const permissionLabelStyles = {
    marginLeft: "5px",
  };
  const invalidFeedbackStyle = {
    color: "red",
    fontSize: "12px",
    marginTop: "-8px",
    marginBottom: "10px",
  };

  return (
    <div className="container-fluid page-body-wrapper">
      {/* Add the Shake Keyframe Animation */}
      <style>
        {`
          @keyframes shake {
            0% { transform: translateX(0); }
            25% { transform: translateX(-5px); }
            50% { transform: translateX(5px); }
            75% { transform: translateX(-5px); }
            100% { transform: translateX(0); }
          }

          .shake {
            animation: shake 0.5s ease-in-out;
          }
            
        `}
      </style>
      <div className="main-panel" >
        <div className="content-wrapper" style={{ paddingBottom: "80px" }}>
          <ToastContainer
                      position="top-center"
                      autoClose={500}
                      hideProgressBar={false}
                      newestOnTop={false}
                      closeOnClick
                      rtl={false}
                      pauseOnFocusLoss
                      draggable
                      pauseOnHover
                      theme="colored"
                    />
          <div className="container mainbody1" style={{ maxWidth: '1900px' }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <h2 className="form-header">Create New Store</h2>
                        <Link to="/liststores" className="btn btn-success btn-sm"><i class="mdi mdi-arrow-right"></i>Store List</Link>
                      </div>
            <form onSubmit={handleFormSubmit} style={{ marginTop: "15px" }}>
              {/* Role label in a separate row */}

              <div className="form-row">
                <div className="form-group col-md-6">
                  <label htmlFor="corporatestorenbr" style={labelStyles}>
                    CorpStore #<span className="requireds">*</span>
                    {isNotExists && (
                      <span style={{ color: "red" }}>
                        (Invalid Store Number!)
                      </span>
                    )}
                    {isDuplicate && (
                      <span style={{ color: "green" }}>
                        (Store already exists!
                        <span
                          onClick={() => goToEditStore(CorpstoreNo)}
                          style={{
                            color: "#007bff",
                            textDecoration: "underline",
                            marginLeft: "5px",
                            cursor: "pointer"
                          }}
                        >
                          Click here to edit
                        </span>
                        )
                      </span>
                    )}

                    {isPrefill && (
                      <span style={{ color: "green" }}>
                        (Store Number does not exist in Shopify. Proceed with the form submission!)
                      </span>
                    )}
                  </label>
                  <input
                    id="corporatestorenbr"
                    type="text"
                    placeholder="Enter corpstore number"
                    value={CorpstoreNo}
                    onChange={handleCorpstoreChange}
                    style={{
                      width: "100%",
                      padding: "8px",
                      marginBottom: "15px",
                      borderRadius: "4px",
                      border: "1px solid #ced4da",
                      fontSize: "14px",
                      height: "47px",
                    }}
                  />
                </div>

                <div className="form-group col-md-6">
                  <label htmlFor="parentno" style={labelStyles}>
                    Parent #<span className="requireds">*</span>
                  </label>
                  <input
                    id="parentno"
                    type="text"
                    placeholder="Enter parent number"
                    value={ParentNo}
                    onChange={(e) => setParentNo(e.target.value)}
                    disabled={fieldsDisabled}
                    style={{
                      width: "100%",
                      padding: "8px",
                      marginBottom: "15px",
                      borderRadius: "4px",
                      border: "1px solid #ced4da",
                      fontSize: "14px",
                      height: "47px",
                    }}
                  />
                </div>
              </div>


              <div className="form-row">
                <div className="form-group col-md-6">
                <label htmlFor="storename" style={labelStyles}>
                  Store Name<span className="requireds">*</span>
                </label>
                <input
                  id="storename"
                  type="text"
                  placeholder="Enter storename"
                  value={StoreName}
                  onChange={(e) => setStoreName(e.target.value)}
                  disabled={fieldsDisabled}
                  style={{
                    width: "100%",
                    padding: "8px",
                    marginBottom: "15px",
                    borderRadius: "4px",
                    border: "1px solid #ced4da",
                    fontSize: "14px",
                    height: "47px",
                  }}
                />
              </div>
              <div className="form-group col-md-6">
                <label htmlFor="storestatus" style={labelStyles}>
                  Store Status<span className="requireds">*</span>
                </label>
                <input
                  id="storestatus"
                  type="text"
                  placeholder="Enter storestatus"
                  value={StoreStatus}
                  onChange={(e) => setStoreStatus(e.target.value)}
                  disabled={fieldsDisabled}
                  style={{
                    width: "100%",
                    padding: "8px",
                    marginBottom: "15px",
                    borderRadius: "4px",
                    border: "1px solid #ced4da",
                    fontSize: "14px",
                    height: "47px",
                  }}
                />
              </div>
              </div>
              <div className="form-row">
                <div className="form-group col-md-6">
                <label htmlFor="storecity" style={labelStyles}>
                  Store Location<span className="requireds">*</span>
                </label>
                <input
                  id="storecity"
                  type="text"
                  placeholder="Enter City, State"
                  value={combinedLocation}
                  disabled={fieldsDisabled}
                  style={{
                    width: "100%",
                    padding: "8px",
                    marginBottom: "15px",
                    borderRadius: "4px",
                    border: "1px solid #ced4da",
                    fontSize: "14px",
                    height: "47px",
                  }}
                />
              </div>

              <div className="form-group col-md-6">
                <label htmlFor="access_token" style={labelStyles}>
                  Access Token<span className="requireds">*</span>
                </label>
                <input
                  id="access_token"
                  type="text"
                  placeholder="Enter access token"
                  value={AccessToken}
                  onChange={(e) => setAccessToken(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "8px",
                    marginBottom: "15px",
                    borderRadius: "4px",
                    border: "1px solid #ced4da",
                    fontSize: "14px",
                    height:"47px"
                  }}
                />
                </div>
                </div>

                <div className="form-row">
                <div className="form-group col-md-6">
                <label htmlFor="api_key" style={labelStyles}>
                  API Key<span className="requireds">*</span>
                </label>
                <input
                  id="api_key"
                  type="text"
                  placeholder="Enter api key"
                  value={ApiKey}
                  onChange={(e) => setApiKey(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "8px",
                    marginBottom: "15px",
                    borderRadius: "4px",
                    border: "1px solid #ced4da",
                    fontSize: "14px",
                    height:"47px"
                  }}
                />
                </div>
                
                <div className="form-group col-md-6">
                <label htmlFor="api_secretkey" style={labelStyles}>
                  API Secret Key<span className="requireds">*</span>
                </label>
                <input
                  id="api_secretkey"
                  type="text"
                  placeholder="Enter api secret key"
                  value={ApiSecretKey}
                  onChange={(e) => setApiSecretKey(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "8px",
                    marginBottom: "15px",
                    borderRadius: "4px",
                    border: "1px solid #ced4da",
                    fontSize: "14px",
                    height:"47px"
                  }}
                />
                </div>
                </div>

                <div className="form-row">
                <div className="form-group col-md-6">
                <label htmlFor="shopify_websiteurl" style={labelStyles}>
                  Shopify Websiteurl<span className="requireds">*</span>
                </label>
                <input
                  id="shopify_websiteurk"
                  type="text"
                  placeholder="Enter shopify websiteurl"
                  value={ShopifyWebsiteurl}
                  onChange={(e) => setShopifyWebsiteurl(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "8px",
                    marginBottom: "15px",
                    borderRadius: "4px",
                    border: "1px solid #ced4da",
                    fontSize: "14px",
                    height:"47px"
                  }}
                />
                </div>

                <div className="form-group col-md-6">
                <label htmlFor="shopify_adminurl" style={labelStyles}>
                  Shopify Adminurl<span className="requireds">*</span>
                </label>
                <input
                  id="shopify_adminurl"
                  type="text"
                  placeholder="Enter shopify adminurl"
                  value={ShopifyAdminurl}
                  onChange={(e) => setShopifyAdminurl(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "8px",
                    marginBottom: "15px",
                    borderRadius: "4px",
                    border: "1px solid #ced4da",
                    fontSize: "14px",
                    height:"47px"
                  }}
                />
                </div>
                </div>
                <div className="form-row">
                <div className="form-group col-md-6">
                <label htmlFor="utc" style={labelStyles}>
                  UTC Hour<span className="requireds">*</span>
                </label>
                <input
                  id="utc"
                  type="text"
                  placeholder="Enter utc hour (-7)"
                  value={Utc}
                  onChange={(e) => setUtc(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "8px",
                    marginBottom: "15px",
                    borderRadius: "4px",
                    border: "1px solid #ced4da",
                    fontSize: "14px",
                    height:"47px"
                  }}
                />
                </div>
                <div className="form-group col-md-6">
                <label htmlFor="utc_dates" style={labelStyles}>
                  UTC Dates(T-1)<span className="requireds">*</span>
                </label>
                <input
                  id="utc_dates"
                  type="text"
                  placeholder="Enter utc (-1)"
                  value={Utcdates}
                  onChange={(e) => setUtcdates(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "8px",
                    marginBottom: "15px",
                    borderRadius: "4px",
                    border: "1px solid #ced4da",
                    fontSize: "14px",
                    height:"47px"
                  }}
                />
                </div>
                </div>
                
                <div className="form-group">
                  {locationIds.map((_, index) => (
                    <div key={index}>
                      <div className="form-row align-items-center mb-2" style={{ gap: "10px" }}>
                        
                      {/* {(index !== 0 || locationIds.length > 1) && ( */}
                        <div className="col">
                          {index === 0 && (
                            <label htmlFor="location_corporatestorenbr" style={labelStyles}>
                              Corporate Store #<span className="requireds">*</span>
                              {index === 0 && corpStoreDuplicate && (
                             <span style={{ color: "red" }}>
                             (CorpStore  No already exists!)
                           </span>
                          )}
                            </label>
                          )}
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Corp StoreNo for new location"
                            value={multilocationcorpStoreNbrs[index - 1] || ""}
                            onChange={(e) => {
                              const value = e.target.value;
                              handleCorpStoreChange(index,value);
                              // Check for duplicate
                              const corpStoreDuplicate = storeList.some(
                                (store) =>
                                  store.shopify_corporatestorenbr?.toString().trim() === value.toString().trim()
                              );
                              setCorpStoreDuplicate(corpStoreDuplicate);
                              if(!corpStoreDuplicate){
                                setCorpStoreDuplicate("");
                              }
                            }}
                          />
                        </div>
                      {/* )} */}
                        <div className="col">
                          {index === 0 && (
                            <label htmlFor="location_id" style={labelStyles}>
                              Location Id<span className="requireds">*</span>
                              {index === 0 && locationIdDuplicate && (
                             <span style={{ color: "red" }}>
                             (Location id already exists!)
                           </span>
                          )}
                            </label>
                          )}
                          <input
                            type="text"
                            placeholder="Location id"
                            className="form-control"
                            value={locationIds[index]}
                            onChange={(e) => {
                              const value = e.target.value;
                              handleLocationIdChange(index, value);

                              // Check for duplicate
                              const locationIdDuplicate = storeList.some(
                                (store) =>
                                  store.location_id?.toString().trim() === value.toString().trim()
                              );
                              setLocationIdDuplicate(locationIdDuplicate);
                              if(!locationIdDuplicate){
                                setLocationIdDuplicate("");
                              }
                            }}
                            
                          />
                        </div>

                        <div className="col">
                          {index === 0 && (
                            <label htmlFor="location_name" style={labelStyles}>
                              Location Name<span className="requireds">*</span>
                            </label>
                          )}
                          <input
                            type="text"
                            placeholder="Location name"
                            className="form-control"
                            value={locationNames[index]}
                            onChange={(e) => handleLocationNameChange(index, e.target.value)}
                          />
                        </div>
                      </div>
                      {index === locationIds.length - 1 && (
                          <div className="form-row">
                            <div className="col-auto">
                              <button
                                type="button"
                                className="btn btn-success btn-block"
                                style={{ minWidth: "150px" }}
                                onClick={handleAddRow}
                              >
                                <FaPlus /> New Location
                              </button>
                            </div>
                          </div>
                        )}
                    </div>
                  ))}
                </div>
 
                <div className="form-group" style={{ display: "flex", flexDirection: "column", position: "relative" }}>
                <label style={{ marginBottom: "8px" }}>
                    Extracts:<span className="requireds">*</span>
                </label>

                {/* Dropdown Button */}
                <div className="dropdown" style={{ width: "100%", position: "relative" }}>
                    <button
                    type="button"
                    className="btn"
                    onClick={() => setShowExtractDropdown(!showExtractDropdown)}
                    style={{
                        width: "100%",
                        height: "20%",
                        color: "#000000",
                        textAlign: "left",
                        padding: "10px 40px 10px 12px",
                        border: "1px solid #ced4da",
                        position: "relative",
                    }}
                    >
                    {extracts.length > 0 ? extracts.join(", ") : "Select Extracts"}

                    {/* Dropdown Icon */}
                    <span
                        style={{
                        position: "absolute",
                        right: "12px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        pointerEvents: "none",
                        }}
                    >
                        ▼
                    </span>
                    </button>

                    {/* Dropdown Menu */}
                    {showExtractDropdown && (
                    <div
                        className="dropdown-menu show"
                        style={{
                        position: "absolute",
                        top: "100%",
                        left: "0",
                        width: "100%",
                        maxHeight: "200px",
                        overflowY: "auto",
                        padding: "10px",
                        zIndex: 999,
                        border: "1px solid #ced4da",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        columnGap: "20px",
                        rowGap: "10px",
                        background: "#fff",
                        }}
                    >
                        {/* Select All Option */}
                        <div style={{ gridColumn: "1 / -1", marginBottom: "5px" }}>
                        <label style={{ display: "flex", alignItems: "center", gap: "10px", cursor: "pointer" }}>
                            <input
                            type="checkbox"
                            checked={extracts.length === extractOptions.length}
                            onChange={(e) => {
                                if (e.target.checked) {
                                setExtracts(extractOptions); // Select all
                                } else {
                                setExtracts([]); // Deselect all
                                }
                            }}
                            style={{ width: "16px", height: "16px" }}
                            />
                            <strong>Select All</strong>
                        </label>
                        </div>

                        {/* Individual Options */}
                        {extractOptions.map((extractItem) => (
                        <label
                            key={extractItem}
                            style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            margin: "0",
                            cursor: "pointer",
                            }}
                        >
                            <input
                            type="checkbox"
                            value={extractItem}
                            checked={extracts.includes(extractItem)}
                            onChange={(e) =>
                                setExtracts((prev) =>
                                e.target.checked
                                    ? [...prev, extractItem]
                                    : prev.filter((val) => val !== extractItem)
                                )
                            }
                            style={{ width: "16px", height: "16px" }}
                            />
                            <span>{extractItem}</span>
                        </label>
                        ))}
                    </div>
                    )}
                </div>
                </div>

                {/* Submit button */}
                <div style={{ display: "flex", gap: "5px" }}>
                    <button
                        type="submit"
                        className="submit-btn"
                        style={{
                            padding: "10px 20px",
                            border: "none",
                            backgroundColor: "#008000",
                            color: "#fff",
                            borderRadius: "4px",
                            cursor: "pointer",
                            fontSize: "16px",
                        }}
                        //onClick={() => navigate("/users")}
                        >
                        Submit
                    </button>
                </div><br></br>
                </form>
                </div>
                </div>
                </div>
                </div>
                );
            };
export default AddStores;
